module.exports = __webpack_public_path__ + "static/media/copyright_logo.892de315.svg";